import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { Constanst } from 'src/app/core/constants/constans.component';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { Select } from 'src/app/shared/models/select';
import { Router } from '@angular/router';
import { DateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-detalle-usuario',
  templateUrl: './detalle-usuario.component.html',
  styleUrls: ['./detalle-usuario.component.css'],
  providers: [DatePipe]
})
export class DetalleUsuarioComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  usuarioForm: FormGroup;
  userName: number = this.data.row.username;
  licenseSerial: string;
  licenseFrom: string | null;
  licenseTo: string | null;
  licensesNumber: number;
  licenseStatus: string;
  userphoneNumber: string;
  companyEmail: string;
  selectedLicense: string;
  //licenseEntities = [];
  licenseEntities: Select[] = [];
  editar: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogDetalleUsuarioRef: MatDialogRef<DetalleUsuarioComponent>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private datePipe: DatePipe,
    private router: Router,
    private dateAdapter: DateAdapter<Date>
  ) { this.dateAdapter.setLocale(Constanst.LOCALE_VE); }

  ngOnInit() {
    this.usuarioForm = new FormGroup({
      name: new FormControl({ value: '', disabled: true }),
      lastname: new FormControl({ value: '', disabled: true }),
      profileName: new FormControl({ value: '', disabled: true }),
      userEmail: new FormControl({ value: '', disabled: true }),
      phoneNumber: new FormControl({ value: '', disabled: true }),
      companyName: new FormControl({ value: '', disabled: true }),
      rif: new FormControl({ value: '', disabled: true }),
      phone: new FormControl({ value: '', disabled: true }),
      fiscalAddress: new FormControl({ value: '', disabled: true }),
      companyEmail: new FormControl({ value: '', disabled: true }),
      serialLicense: new FormControl({ value: '', disabled: false }),
      initDate: new FormControl({ value: '', disabled: true }),
      endDate: new FormControl({ value: '', disabled: true }),
      isExpired: new FormControl({ value: '', disabled: true }),
      licensesNumber: new FormControl({ value: '', disabled: true })
    });
    this.licenseSerial = '';
    this.licenseFrom = '';
    this.licenseTo = '';
    this.userphoneNumber = '';
    this.companyEmail = '';
    this.getInfoUser();
  }

  getInfoUser() {
    this.route = '/getUserById';
    this.method = 'POST';
    let notLicenseExipered = false;
    let data = {
      idUser: this.data.row.idUser
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          //console.log(response);
          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {

            //Validacion de Licencias y obtención de la seleccionada en tabla
            this.licensesNumber = response.data.licenseEntities.length;
            if (this.licensesNumber == 1) {
              this.selectedLicense = response.data.licenseEntities[0].idLicense;
              let liceOpt: Select = { id: '', value: '' };
              liceOpt.id = response.data.licenseEntities[0].idLicense;
              liceOpt.value = response.data.licenseEntities[0].serialLicense + "(" + (response.data.licenseEntities[0].expired ? "Inactiva" : "Activa") + ")";
              this.licenseEntities.push(liceOpt);

              this.licenseFrom = this.datePipe.transform(response.data.licenseEntities[0].initDate, 'dd/MM/yyyy');
              this.licenseTo = this.datePipe.transform(response.data.licenseEntities[0].endDate, 'dd/MM/yyyy');
              this.licenseStatus = (response.data.licenseEntities[0].expired ? 'Inactivo' : 'Activo');

            } else {
              for (let i = 0; i < this.licensesNumber; i++) {

                let data = response.data.licenseEntities[i];
                let liceOpt: Select = { id: '', value: '' };
                liceOpt.id = data.idLicense;
                liceOpt.value = data.serialLicense + "(" + (data.expired ? "Inactiva" : "Activa") + ")";
                this.licenseEntities.push(liceOpt);

                if (!data.expired) {
                  notLicenseExipered = true;
                  this.selectedLicense = response.data.licenseEntities[i].idLicense;
                  this.licenseFrom = this.datePipe.transform(response.data.licenseEntities[i].initDate, 'dd/MM/yyyy');
                  this.licenseTo = this.datePipe.transform(response.data.licenseEntities[i].endDate, 'dd/MM/yyyy');
                }
              }
              if (!notLicenseExipered) {//todas expiradas, se toma la primera.
                let size = this.licenseEntities.length;
                this.selectedLicense = response.data.licenseEntities[(size - 1)].idLicense;
                this.licenseFrom = this.datePipe.transform(response.data.licenseEntities[(size - 1)].initDate, 'dd/MM/yyyy');
                this.licenseTo = this.datePipe.transform(response.data.licenseEntities[(size - 1)].endDate, 'dd/MM/yyyy');
                this.licenseStatus = 'Inactivo';
              } else {
                this.licenseStatus = (this.data.row.expired ? 'Inactivo' : 'Activo');
              }
            }

            localStorage.setItem(Constanst.STORAGE_DATA_USERSELECT, response.data.idUser);

            //Validacion de Campos opcionales
            if (this.userphoneNumber === null || this.userphoneNumber.length === 0 || this.userphoneNumber.trim() === '') {
              this.userphoneNumber = 'No indicado';
            }
            if (this.companyEmail === null || this.companyEmail.length === 0 || this.companyEmail.trim() === '') {
              this.companyEmail = 'No indicado';
            }

            this.usuarioForm = new FormGroup({
              name: new FormControl({ value: response.data.fullName, disabled: true }),
              profileName: new FormControl({ value: response.data.profileEntity.profileName, disabled: true }),
              userEmail: new FormControl({ value: response.data.email, disabled: true }),
              phoneNumber: new FormControl({ value: response.data.phoneNumber, disabled: true }),
              companyName: new FormControl({ value: response.data.companyEntity.companyName, disabled: true }),
              rif: new FormControl({ value: response.data.companyEntity.rif, disabled: true }),
              phone: new FormControl({ value: response.data.companyEntity.phone, disabled: true }),
              fiscalAddress: new FormControl({ value: response.data.companyEntity.fiscalAddress, disabled: true }),
              companyEmail: new FormControl({ value: response.data.companyEntity.email, disabled: true }),
              serialLicense: new FormControl({ value: this.licenseSerial, disabled: true }),
              initDate: new FormControl({ value: this.licenseFrom, disabled: true }),
              endDate: new FormControl({ value: this.licenseTo, disabled: true }),
              isExpired: new FormControl({ value: this.licenseStatus, disabled: true }),
              licensesNumber: new FormControl({ value: (response.data.companyEntity.licenseNumber + 1), disabled: true })
            });

            this.apiCallService.hideSpinner();
          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }

        });
  }

  onSubmit(): void {
    if (this.usuarioForm.invalid) {
      return;
    } else {
      return this.confirm();
    }
  }

  confirm() {
    const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_UPDATE, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);

    dialog.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        let initDateString = this.usuarioForm.controls['initDate'].value;
        let [dayInit, monthInit, yearInit] = initDateString.split('/');
        let newInitDate = new Date(+yearInit, +monthInit - 1, +dayInit);

        let endDateString = this.usuarioForm.controls['endDate'].value;
        let [dayEnd, monthEnd, yearEnd] = endDateString.split('/');
        let newEndDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd);

        this.route = '/editProfile';
        this.method = 'POST';
        let data = {
          userEntity: {
            idUser: localStorage.getItem(Constanst.STORAGE_DATA_USERSELECT),
            fullName: this.usuarioForm.controls['name'].value,
            phoneNumber: this.usuarioForm.controls['phoneNumber'].value,
            email: this.usuarioForm.controls['userEmail'].value
          },
          companyEntity: {
            rif: this.usuarioForm.controls['rif'].value,
            companyName: this.usuarioForm.controls['companyName'].value,
            email: this.usuarioForm.controls['companyEmail'].value,
            fiscalAddress: this.usuarioForm.controls['fiscalAddress'].value,
            phone: this.usuarioForm.controls['phone'].value,
            licenseNumber: this.usuarioForm.controls['licensesNumber'].value
          },
          licenseEntity: {
            idLicense: this.usuarioForm.controls['serialLicense'].value,
            // initDate: this.datePipe.transform(this.usuarioForm.controls['initDate'].value, 'yyyy-MM-dd'),
            initDate: newInitDate,
            endDate: newEndDate
            // endDate: this.datePipe.transform(this.usuarioForm.controls['endDate'].value, 'yyyy-MM-dd')
          }
        }

        this.apiCallService.call$(data, this.route, this.method, true, '', true)
        .pipe(takeUntil(this.destroy$))
        .subscribe(response => {
          this.apiCallService.hideSpinner();
          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            this.helperClassService.notifierUpdatedUser.emit('UpdatedUser');
            const dialogUpdate = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_USER_UPDATED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
            dialogUpdate.afterClosed().subscribe((result: string) => {
              this.closeDialogDetalleUsuario();
            });
          } else {
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_USER_UPDATED_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
          }
        },
          error => {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
        );
      } else {
        dialog.close(false);
      }
    });
  }

  resetUser() {
    const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_RESET, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialog.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.route = '/resetUser';
        this.method = 'POST';
        let data = {
          idUser: localStorage.getItem(Constanst.STORAGE_DATA_USERSELECT)
        }

        this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$))
          .subscribe(response => {
            this.apiCallService.hideSpinner();
            if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_USER_RESETED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
              this.closeDialogDetalleUsuario();
            } else {
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
            }
          },
            error => {
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
            }
          );
      } else {
        dialog.close(false);
      }
    });
  }

  disableUser() {
    const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_DISABLE, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialog.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.route = '/disableUser';
        this.method = 'POST';
        let data = {
          idUser: localStorage.getItem(Constanst.STORAGE_DATA_USERSELECT)
        }

        this.apiCallService.call$(data, this.route, this.method, true, '', true)
        .pipe(takeUntil(this.destroy$))
        .subscribe(response => {
          this.apiCallService.hideSpinner();
          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            this.helperClassService.notifierUpdatedUser.emit('UpdatedUser');
            const dialogDelete = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_USER_DELETED_SUCCESS, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
            dialogDelete.afterClosed().subscribe((result: string) => {
              this.closeDialogDetalleUsuario();
            });
          } else {
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_USER_ALREADY_DELETED, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
          }
        },
          error => {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
        );
      } else {
        dialog.close(false);
      }
    });
  }

  closeDialogDetalleUsuario() {
    this.dialogDetalleUsuarioRef.close();
  }

  habilitarCampos() {
    //console.log('en habilitar campos');
    this.usuarioForm.get('name')?.enable();
    this.usuarioForm.get('userEmail')?.enable();
    this.usuarioForm.get('phoneNumber')?.enable();
    this.usuarioForm.get('companyName')?.enable();
    this.usuarioForm.get('rif')?.enable();
    this.usuarioForm.get('phone')?.enable();
    this.usuarioForm.get('fiscalAddress')?.enable();
    this.usuarioForm.get('companyEmail')?.enable();
    this.usuarioForm.get('initDate')?.enable();
    this.usuarioForm.get('endDate')?.enable();
    this.usuarioForm.get('licensesNumber')?.enable();
    this.editar = false;

  }

}
